import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import Header from "../Header/Navbar";
import InputAdornment from "@mui/material/InputAdornment";
import Input from "@mui/material/Input";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { setDeliveryAddress } from "store/Reducers/DeliveryAddress";
// import bgimgg from './images/LandingPageBg.svg'
export default function HeroSection({ handleMainModal }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [deliveryAddressState, setDeliveryAddressState] = useState("");
  const isButtonDisabled = deliveryAddressState === "";
  const handleDeliveryAddress = (e) => {
    var value = e.target.value;
    setDeliveryAddressState(value);
  };
  const handleExploreClick = () => {
    dispatch(setDeliveryAddress(deliveryAddressState));
    navigate(`/allmenu?q=${deliveryAddressState}`);
  };
  return (
    <>
      <Box
        component={"container"}
        bgcolor="#F9FFFF"
        sx={{
          display: {
            xs: "block",
            sm: "block",
            md: "block",
            lg: "block",
          },
          backgroundImage: "url(./images/LandingPageBg.svg)",
          backgroundRepeat: "no-repeat",

          width: "100%",
          height: {
            xl: "800px",
            lg: "700px",
            md: "560px",
            sm: "700px",
            xs: "500px",
          },
          backgroundSize: {
            xl: "cover",
            lg: "cover",
            md: "cover",
            sm: "contain",
            xs: "cover",
          },
          backgroundPosition: "center",
          // border:"1px solid red"
        }}
      >
        <Box>
          <Header />
        </Box>

        <Box
          sx={{
            paddingLeft: {
              xl: "72px",
              lg: "72px",
              sm: "30px",
              xs: "30px",
            },
          }}
        >
          <Box>
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: {
                  xl: "56px",
                  lg: "56px",
                  md: "56px",
                  sm: "44px",
                  xs: "30px",
                },
                width: {
                  xl: "682px",
                  md: "682px",
                  lg: "682px",
                  sm: "500px",
                  xs: "280px",
                },

                lineHeight: {
                  xl: "61.6px",
                  lg: "61.6px",
                  md: "61.6px",
                  sm: "51.6px",
                  xs: "41.6px",
                },
                alignItems: { sm: "flex-start" },
                paddingTop: {
                  xl: "281px",
                  sm: "200px",
                  xs: "74px",
                },
              }}
            >
              Easy of Ordering food in your busy schedule
            </Typography>

            <Box
              sx={{
                marginTop: "32px",
                display: "flex",
                flexDirection: {
                  lg: "row",
                  md: "row",
                  sm: "row",
                  xs: "row",
                },
                // border: "1px solid red",
                px: { lg: 0, md: 0, sm: 1, xs: 1 },
              }}
            >
              <Input
                placeholder="Enter delivery  address"
                id="standard-adornment-amount"
                disableUnderline="true"
                startAdornment={
                  <InputAdornment position="start">
                    <img
                      src="./images/LocationRed.svg"
                      sx={{
                        width: "17.75px",
                        height: "20.5px",
                      }}
                      alt=""
                    />
                  </InputAdornment>
                }
                value={deliveryAddressState}
                onChange={handleDeliveryAddress}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    // Call function to handle Enter key press event
                    handleExploreClick();
                  }
                }}
                sx={{
                  borderColor: "#E1E1E6",
                  border: "1px solid",
                  width: {
                    lg: "484px",
                    md: "484px",
                    sm: "45%",
                    xs: "auto",
                  },
                  height: {
                    lg: "68px",
                    xs: "55px",
                  },
                  borderRadius: "8px",
                  padding: "15px, 24px, 15px, 24px",
                  gap: { lg: "16px", md: "16px", sm: "0px", xs: "0px" },
                  backgroundColor: "#FFFFFF",
                  color: "#9EA3AE",
                  paddingLeft: "27.12px",
                }}
              />

              <Button
                variant="contained"
                onClick={handleExploreClick}
                disabled={isButtonDisabled}
                sx={{
                  textTransform: "capitalize",
                  marginLeft: "10px",
                  size: { lg: "large", md: "medium", sm: "small", xs: "small" },
                  fontSize: { lg: "20px", md: "20px", sm: "10px", xs: "10px" },
                  mt: { lg: 0, md: 0, sm: 1, xs: 1 },
                  // border:"1px solid red"
                }}
                startIcon={<SearchIcon width="100%" />}
              >
                Explore
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
